define('core/modules/subnav',["jquery", "modernizr", "libs/enquire", "waypoints"], function ($, Modernizr, enquire) {
    return {
         init: function() {
             console.log('subnav');
 
             //Find the subnav container.  Then find its parent container to calculate the pixel
             // distance from the top of the body to the top of the subnav.
             var subnav = document.querySelector('.subnav');
             var main = document.querySelector('#main');
             var spaceAboveSubnav = main.offsetTop;

             function applyStickToSubnavOnDesktop() {
                 if (window.innerWidth > 1024) {
                     stickSubNav();
                 } else {
                     removeClassesAndBodyPadding();
                 }
             }

             // helper function to close subnav on mobile
             function close($el) {
                 $el.removeClass('subnav-open');
                 $(document).off('touchstart.subnav');
             }

             function removeClassesAndBodyPadding() {
                 document.body.style.paddingTop = '0px';
                 subnav.classList.remove('stuck');
             }
  
             function stickSubNav() {
                 if (window.scrollY >= spaceAboveSubnav) {
                     document.body.style.paddingTop = subnav.offsetHeight + 'px';
                     subnav.classList.add('stuck');
                 } else {
                     removeClassesAndBodyPadding();
                 }
             }
            
             // test for touch functionality
             if (!EFTOURS.device.isTouch) {  
                 window.addEventListener('resize', applyStickToSubnavOnDesktop); 
                 window.addEventListener('scroll', applyStickToSubnavOnDesktop);                             
             } else {
                 const isMobile = $('.subnav').hasClass('subnav-mobile');
 
                 $('.subnav-haschildren > .subnav-item-link').on('click.subnav', function(evt) {
                     var $this = $(this),
                         $parent = $this.parent('.subnav-haschildren');
                     evt.preventDefault();
                     evt.stopPropagation();
 
                     // if already open, close
                     if ($parent.hasClass('subnav-open')) {
                         close($parent);
                     }
                     else {
                         // add open class
                         $parent.addClass('subnav-open');
 
                         // if not full-width nav, it's ok to turn it off when you click outside, otherwise, let them scroll down
                         if (!isMobile) {
                             $(document).on('touchstart.subnav', function(event) {
                                 if (!$(event.target).parents('.subnav-haschildren').is($parent)) {
                                     close($parent);
                                 }
                             });
                         }
                     }
                 });
             }
         }
     }
 });
